import ReactGA from 'react-ga4'

export function pageview(action: string): void {
  ReactGA.event({
    category: 'page_view',
    action,
  })
}

export function ga4Event(
  action: string,
  options?: { label?: string; value?: number },
): void {
  ReactGA.event({
    category: 'click',
    action,
    label: options?.label,
    value: options?.value,
  })
}
